module.exports = "/_next/static/images/img__teachers_left_bottom_desktop-55981b0869335d1ce41e2da18ebae173.png";